/* navigation */

/* positionnement sous nav avec images */
var width = 0;
$('#menu-item-809>a>img').hide()
$('#menu-item-809 .sub-menu li').each(function(index, el) {
	width += $(this).outerWidth();
  $(this).parent().css('width', width+'px');
  if(index > $(this).length){
    var padding = parseInt($(this).parent().css('padding-left').replace(/[^-\d\.]/g, ''))*2;
    $(this).parent().css('width', width+padding+'px');
  }
});

$('#menu-item-9407>a>img').hide()
$('#menu-item-9407 .sub-menu li').each(function(index, el) {
	width += $(this).outerWidth();
  $(this).parent().css('width', width+'px');
  if(index > $(this).length){
    var padding = parseInt($(this).parent().css('padding-left').replace(/[^-\d\.]/g, ''))*2;
    $(this).parent().css('width', width+padding+'px');
  }
});

$('.burger-wrapper').click(function (e) {
  $('.burger').toggleClass('active');
  $('.cross').toggleClass('active');
  $('.mobilenav-wrapper').toggleClass('active');
})

$('.cross').click(function (e) {
  $(this).toggleClass('active');
  $('.burger').toggleClass('active');
  $('.mobilenav-wrapper').toggleClass('active');
})
